import { render, staticRenderFns } from "./GiftshopSelectionModalProduct.vue?vue&type=template&id=09e5c058&"
import script from "./GiftshopSelectionModalProduct.vue?vue&type=script&lang=ts&"
export * from "./GiftshopSelectionModalProduct.vue?vue&type=script&lang=ts&"
import style0 from "./GiftshopSelectionModalProduct.vue?vue&type=style&index=0&id=09e5c058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports